// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WaitingRoomMemberCard__member-card-container-cc273f {
  overflow: hidden;
  position: relative;
  display: flex;
  padding: 8px 16px;
}

.WaitingRoomMemberCard__avatar-container-cc66f0 {
  position: relative;
  flex: 0 0 auto;
}

.WaitingRoomMemberCard__content-d62774 {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  margin-inline-start: 12px;
  margin-inline-end: 12px;
  overflow: hidden;
  justify-content: center;
}

.WaitingRoomMemberCard__title-f6dd47 {
  display: flex;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--addition-50);
}

.WaitingRoomMemberCard__title-name-b0a619 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.WaitingRoomMemberCard__actions-d6fa03 {
  display: flex;
  min-width: 40px;
  flex: 0 0 auto;
  align-items: center;
  margin-inline-start: auto;
}

.WaitingRoomMemberCard__action-aff156 {
  display: flex;
  align-items: center;
  margin-inline-end: 16px;
}

.WaitingRoomMemberCard__action-aff156:last-child {
  margin-inline-end: 0;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/WaitingRoomList/WaitingRoomMemberCard/WaitingRoomMemberCard.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,wBAAA;EACA,0CAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".member-card-container {\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  padding: 8px 16px;\n}\n\n.avatar-container {\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.content {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  margin-inline-start: 12px;\n  margin-inline-end: 12px;\n  overflow: hidden;\n  justify-content: center;\n}\n\n.title {\n  display: flex;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--addition-50);\n}\n\n.title-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.actions {\n  display: flex;\n  min-width: 40px;\n  flex: 0 0 auto;\n  align-items: center;\n  margin-inline-start: auto;\n}\n\n.action {\n  display: flex;\n  align-items: center;\n  margin-inline-end: 16px;\n}\n\n.action:last-child {\n  margin-inline-end: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"member-card-container": `WaitingRoomMemberCard__member-card-container-cc273f`,
	"memberCardContainer": `WaitingRoomMemberCard__member-card-container-cc273f`,
	"avatar-container": `WaitingRoomMemberCard__avatar-container-cc66f0`,
	"avatarContainer": `WaitingRoomMemberCard__avatar-container-cc66f0`,
	"content": `WaitingRoomMemberCard__content-d62774`,
	"title": `WaitingRoomMemberCard__title-f6dd47`,
	"title-name": `WaitingRoomMemberCard__title-name-b0a619`,
	"titleName": `WaitingRoomMemberCard__title-name-b0a619`,
	"actions": `WaitingRoomMemberCard__actions-d6fa03`,
	"action": `WaitingRoomMemberCard__action-aff156`
};
module.exports = ___CSS_LOADER_EXPORT___;
